<template>
  <el-form class="search_form" :model="searchForm" ref="searchForm" size="mini" :inline="true" :rules="searchFormRules">
    <el-col :span="3">
      <el-form-item prop="operatorId">
<!--        <el-select placeholder="运营商" v-model="searchForm.operatorId" clearable @change="operatorSelect">
          <el-option v-for="item in operatorForSelect" :key="item.id"
                     v-bind:label="item.name" v-bind:value="item.id"></el-option>
        </el-select>-->
        <el-cascader  size="mini" clearable  ref="cascader"
                      placeholder="运营商"  filterable
                      :options="operatorForSelect"
                      :show-all-levels="false"
                      :props="{ checkStrictly:true,expandTrigger:'hover'}"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="searchForm.operatorId">
        </el-cascader>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="stationId">
        <el-select placeholder="所属站" v-model="searchForm.stationId" clearable>
          <el-option v-for="item in stationsForSelect" :key="item.id"
                     v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="pileCode">
        <el-input placeholder="桩编号" v-model="searchForm.pileCode" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="gunCode">
        <el-input placeholder="充电枪编号" v-model="searchForm.gunCode" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="state">
        <el-form-item prop="state">
          <el-select placeholder="枪工作状态" v-model="searchForm.state" clearable>
            <el-option v-for="item in stateData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitSearchForm"
                   :loading="searchLoading">查询
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import {validateInput} from '../../../../common/validator'
  export default {
    name: "search",
    data(){
      return{
        searchFormRules: {
          pileCode: [
            {validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,20,true,true,true,false,false,false,false)
              }, trigger: 'blur'}],
          gunCode: [
            {validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,21,true,true,true,false,false,false,false)
              }, trigger: 'blur'}],
        }
      }
    },
    props:{
      searchForm:{},
      stationsForSelect: '',
      operatorForSelect: '',
      searchLoading: false,
      stateData:""
    },
    methods:{
      resetSearchForm() {
        for(let item in this.searchForm) {
          if(this.searchForm[item]){
            this.searchForm[item] = ''
          }
        }
        this.submitSearchForm()
      },
      submitSearchForm(){
        this.$emit("submitSearchForm")
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/search.vue